// extracted by mini-css-extract-plugin
export var bubble = "_15-0";
export var container = "_15-f";
export var contrastBorder = "_15-g";
export var greyOut = "_15-2";
export var initialsColor0 = "_15-3";
export var initialsColor1 = "_15-4";
export var initialsColor10 = "_15-d";
export var initialsColor11 = "_15-e";
export var initialsColor2 = "_15-5";
export var initialsColor3 = "_15-6";
export var initialsColor4 = "_15-7";
export var initialsColor5 = "_15-8";
export var initialsColor6 = "_15-9";
export var initialsColor7 = "_15-a";
export var initialsColor8 = "_15-b";
export var initialsColor9 = "_15-c";
export var initialsWrapper = "_15-1";
export var large = "_15-l";
export var medium = "_15-k";
export var mediumSmall = "_15-j";
export var mediumSmallMedium = "_15-o";
export var micro = "_15-h";
export var small = "_15-i";
export var tiny = "_15-n";
export var xTiny = "_15-m";